import { useLazyQuery } from "@apollo/client";
import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import { theme } from "config/theme";
import useText from "constants/text";
import { ITourTemplateAxe, NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import { GET_DETAILS_ADDR } from "domains/Request/graphql/queries";
import React, { useEffect, useState } from "react";
import SchedulingDetails from "../../shared/RightSideComponents/components/SchedulingDetails";
import { CollipsableStopsTour } from "./Collapse";
import Navigation from "./Navigation";
interface Props {
  onNext: () => void;
  onBack: () => void;
}

const useStyles = makeStyles(() => ({
  container: {
    height: "63vh",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      height: "60vh",
    },
  },
  hr: {
    width: "93%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
    [theme.breakpoints.down("xs")]: {
      width: "87%",
    },
  },
  hr2: {
    width: "76%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
    [theme.breakpoints.down("xs")]: {
      width: "74%",
    },
  },
  hr3: {
    width: "67%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
    [theme.breakpoints.down("xs")]: {
      width: "65%",
    },
  },
  p: {
    color: "#757a93",
    fontSize: "14px",
    width: "90%",
    wordWrap: "break-word",
  },
  gridStyle: {
    display: "flex",
    alignItems: "center",
    color: "#399ebf",
    fontSize: 12,
    fontWeight: "bold",
  },
  paddingGrid: {
    padding: "0px 15px",
  },
  padding: {
    padding: "15px 0px",
  },
  countryMap: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
}));

export const Recap = ({ onNext, onBack }: Props) => {
  const { text } = useText();
  const styles = useStyles();
  const { requestQuoteTour, requestQuote, requestQuoteDetails } = React.useContext(NewRequestQuoteContext);
  const [getDetailsAddr, { data }] = useLazyQuery(GET_DETAILS_ADDR, { fetchPolicy: "network-only" });
  const getAllPlaceIds = () => {
    const placeIds: any[] = [];
    requestQuoteTour.templateAxes.forEach((axe: ITourTemplateAxe) => {
      axe?.templateStops?.map((stop) => placeIds.push(stop?.address?.place_id));
    });
    return placeIds;
  };
  const [requestToDisplay, setRequestToDisplay] = useState<any>(null);
  useEffect(() => {
    setRequestToDisplay(requestQuoteDetails || requestQuote || requestQuoteTour);
    // eslint-disable-next-line
  }, [requestQuote, requestQuoteTour, requestQuoteDetails]);

  React.useEffect(() => {
    if (requestQuoteTour) {
      const placeIDs = getAllPlaceIds();
      getDetailsAddr({
        variables: {
          queries: {
            placeIDs,
          },
        },
      });
    }
  }, []);

  return (
    <>
      <div className={styles.container}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6} className={styles.paddingGrid}>
            <div className={styles.gridStyle}>
              Stops
              <hr className={styles.hr} />
            </div>
            <Grid container className={styles.padding}>
              <Grid item xs={12} md={12}>
                <CollipsableStopsTour requestQuoteTour={requestQuoteTour} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <SchedulingDetails requestToDisplay={requestQuoteTour} isDisabled />
              </Grid>
              <Grid item xs={12} md={12}>
                {requestQuoteTour?.additionnalInfos && (
                  <>
                    <Paper>
                      <Grid item xs={12} md={12} className={styles.gridStyle}>
                        {text.all.additional_infos}
                        <hr className={styles.hr3} />
                      </Grid>
                    </Paper>
                    <Paper>
                      <Grid item xs={12} md={12}>
                        <Typography className={styles.p}>{requestQuoteTour?.additionnalInfos}</Typography>
                      </Grid>
                    </Paper>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Navigation nextTitle={text.all.confirm} onNext={onNext} previousTitle={text.all.previous} onPrevious={onBack} />
    </>
  );
};
